import { render, staticRenderFns } from "./lookview.vue?vue&type=template&id=61b172ee&scoped=true"
import script from "./lookview.vue?vue&type=script&lang=js"
export * from "./lookview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b172ee",
  null
  
)

export default component.exports